import { Experience, PartnerPackageWithExpandedProducts } from "types";

export const getSellerExperiencesFromPartnerPackage = (
    pkg: PartnerPackageWithExpandedProducts,
    sellerId: string,
): Experience[] => {
    return pkg.selectedProducts
        .filter((selectedProduct) => selectedProduct.product?.seller?.id === sellerId)
        .map((selectedProduct) => selectedProduct.product);
};
